const mobilePass = {
  addMobileCredentials: 'Add mobile credentials',
  count: '<1>{{count}}</1> mobile credential(s) available',
  modalTitle: 'KRYPTO Mobile-PASS purchasing',
  accountName: 'Account name: ',
  purchaseHistory: 'Purchase history: ',
  currentlyAvailable: 'Currently available: ',
  warning:
    'You are about to purchase {{ number }} KRYPTO Mobile-PASS for a total of {{ price }}. Are you sure?',
  outOfMobilePasses:
    'You are out of mobile passes, please contact your dealer to add more on your account.',
  count_one: 'You have <1>{{ count }}</1> mobile credential available.',
  count_other: 'You have <1>{{ count }}</1> mobile credentials available.',
};

export default mobilePass;
